export default "/static/webpack/media/skill-model-nb.63728e69.png";